// Wrap fn so it runs once, just AFTER the next paint, coalescing repeated calls
// within a burst into a single run. requestAnimationFrame fires BEFORE paint;
// the nested setTimeout(0) then runs right after the frame is painted — so the
// work stays out of the triggering interaction's presentation-delay window
// (unlike rafThrottle, which runs before paint). Use for expensive layout work
// (e.g. Swiper.update) that should settle after the interaction has painted.
export const coalesceAfterPaint = (fn) => {
    let scheduled = false;

    return function coalescedAfterPaint(...args) {
        if (scheduled) {
            return;
        }

        scheduled = true;

        requestAnimationFrame(() => {
            setTimeout(() => {
                scheduled = false;
                fn.apply(this, args);
            }, 0);
        });
    };
};
